import { Injectable } from '@angular/core';
import { TBXResponseWrapperError } from '@tc-core/model/it/codegen/tbx/api/tbx-response-wrapper';
import { TcErrorType } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-error';
import { ErrorView } from '@tc-core/model/it/codegen/ui/error-view';
import { ConfigLoader } from '@tc-core/util/framework/config-loader.service';
import { DataKey, DataStoreService } from './data-store.service';

/**
 * Copyright (c) 2016. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by nuwanw
 * Date : 8/23/2017
 * Time : 7:32 PM
 */
@Injectable()
export class ErrorProcessorService {

    constructor(
        private configLoader: ConfigLoader,
        private dataStore: DataStoreService
    ) {
    }

    public processBackendDmcError(error: TBXResponseWrapperError) {
        let errorView: ErrorView = null;
        errorView = new ErrorView();
        errorView.errors = [];

        errorView.initiator = '';
        errorView.type = TcErrorType.TYPE.ERROR.toString();
        if (error) {
            errorView.errorMessage = error.message;
            errorView.autoDismiss = false;
            errorView.dismissDuration = 3000;
            this.dataStore.set(DataKey.error, errorView);
            console.error(error.message);
            console.error(error.details);
        }
    }

    public processBackendError(status: number) {
        let errorView: ErrorView = null;
        errorView = new ErrorView();
        errorView.errors = [];

        errorView.initiator = '';
        errorView.type = TcErrorType.TYPE.ERROR.toString();
        errorView.errorMessage = 'Error occurred, Status code: ' + status;
        errorView.autoDismiss = false;
        errorView.dismissDuration = 3000;
        this.dataStore.set(DataKey.error, errorView);
    }


// public process(tcError: TcError) {
//   let errorView: ErrorView = null;
//
//   if (tcError) {
//     errorView = new ErrorView();
//     errorView.errors = [];
//
//     errorView.initiator = tcError.initiator;
//     errorView.type = TcErrorType.TYPE[tcError.type];
//
//     // read error config
//     const errorConfig: ErrorConfig = this.configLoader.conf([TCO.CONF.ERROR_CONFIG])[tcError.initiator];
//     if (errorConfig) {
//
//       // set error type & error message properties
//       errorView.errorMessage = errorConfig.defaultErrorMesage;
//       errorView.autoDismiss = errorConfig.autoDismiss;
//       errorView.dismissDuration = errorConfig.dismissDuration ? errorConfig.dismissDuration : 3000;
//       errorView.type = errorConfig.type ? errorConfig.type : TcErrorType.TYPE[TcErrorType.TYPE.ERROR];
//
//       if (tcError instanceof TcHttpError) {
//
//         let httpError: TcHttpError<any> = <TcHttpError<any>> tcError;
//
//         if (errorConfig.showApiError) {
//           let httpErrorObject = httpError.httpResponse;
//           if (httpErrorObject) {
//             let httpStatus = httpErrorObject.status;
//             let mappedHttpError = errorConfig.httpCodes[httpStatus];
//             errorView.errors.push(mappedHttpError);
//             let jsonError;
//             // map the api errors comes inside the http response body
//             // if (this.jsonUtilService.isJsonBody(httpErrorObject)) {
//             if (httpErrorObject.error) {
//               let jsonError = httpErrorObject.error['error'];
//             } else if (httpErrorObject instanceof HttpErrorResponse) {
//               jsonError = httpErrorObject.error.error;
//             }
//
//             if (jsonError) {
//
//               let errorList: Array<string> = [];
//               let code = jsonError.code ? errorList.push(jsonError.code) : '';
//               let message = jsonError.message ? errorList.push(jsonError.message) : '';
//               let details = jsonError.details ? errorList.push(jsonError.details) : '';
//               let errorMsg = errorList.join(' - ');
//               errorView.errors.push(errorMsg);
//
//               if (jsonError.errors && jsonError.errors.length > 0) {
//                 jsonError.errors.forEach((item) => {
//                   errorView.errors.push(item);
//                 });
//               }
//
//             }
//           }
//         }
//
//         // set the session id to the ErrorView object
//         errorView.sessionId = this.baseService.getSessionId();
//
//       }
//       else if (tcError instanceof TcApiError) {
//
//         let apiError = <TcApiError>tcError;
//         let apiResultError: TBXResponseWrapperError = apiError.tcResultError;
//
//         let errorList: Array<string | number> = [];
//         let code = apiResultError.code ? errorList.push(apiResultError.code) : '';
//         let message = apiResultError.message ? errorList.push(apiResultError.message) : '';
//         let details = apiResultError.details ? errorList.push(apiResultError.details) : '';
//         let errorMsg = errorList.join(' - ');
//         errorView.errors.push(errorMsg);
//
//         if (apiResultError && apiResultError.errors && apiResultError.errors.length > 0) {
//
//           apiResultError.errors.forEach((item) => {
//             errorView.errors.push(item);
//           });
//         }
//
//         // set the session id to the ErrorView object
//         errorView.sessionId = this.baseService.getSessionId();
//
//       }
//       else if (tcError instanceof TcError) {
//         // set the session id to the ErrorView object
//         errorView.sessionId = this.baseService.getSessionId();
//       }
//
//       this.dataStore.set(DataKey.error, errorView);
//
//     } else {
//       errorView.errorMessage = 'Error occurred.';
//       errorView.autoDismiss = false;
//       errorView.dismissDuration = 3000;
//       this.dataStore.set(DataKey.error, errorView);
//
//       // set the session id to the ErrorView object
//       errorView.sessionId = this.baseService.getSessionId();
//     }
//   }
// }
}
